export enum STORAGE_KEY {
  SEARCH_HISTORY = 'searchHistory',
  EASY_CERTIFICATION = 'easyCertification',
  KOSAF_PROCESS = 'kosafProcess',
  JEJU_YOUTHDREAM = 'jejuYouthdream',
  LOGOUT_TOAST = 'logoutToast',
  POLICY_FILTER_LANDING = 'policyFilterLanding',
  POLICY_FILTER_LANDING_FROM = 'policyFilterFrom',
  POLICY_FILTER = 'policyFilter',
  MY_INFO_PROFILE_SCRAP_ACTIVE_TAB = 'myInfoProfileScrapActiveTab',

  //* 회원 가입시 어떤 사용자가 추천했는지를 구분할 수 있는 코드
  MEMBER_CODE = 'memberCode',

  //* 회원가입 이벤트 로그를 위한 정보
  SIGNUP_METHOD = 'signupMethod',
  SIGNUP_TYPE = 'signupType',

  //* 가입 V3 세션 참조키(본인인증 왕복 중 userTempKey 유지)
  SIGNUP_V3_USER_TEMP_KEY = 'signupV3UserTempKey',
  //* 가입 V3 위치서비스 동의 선택값(가입완료 후 서버 동기화용 — 본인인증 왕복 간 유지)
  SIGNUP_V3_LOCATION_CONSENT = 'signupV3LocationConsent',
  //* 로그인 진행 중 여부
  IS_LOGIN_PROGRESS = 'isLoginProgress',

  //* 웰퍼 신청 프로세스 중에 임시로 저장해 놓는 정책 분야 태그들
  WELLPER_APPLY_POLICY_TEMP_VALUES = 'wellperApplyPolicyTempValues',

  //* 럭키볼 관련
  OPEN_ONCE_LUCKY_BALL_MODAL_BY_HOME = 'openOnceLuckyBallModalByHome',
  SHOW_ONCE_GET_LUCKY_BALL_TOAST_BY_MY_LUCKY_BALL = 'showOnceGetLuckyBallToastByMyLuckyBall',

  //* history 관련 정보
  HISTORY = 'history',
  HISTORY_EXPIRE = 'historyExpire',
  HISTORY_INDEX = 'historyIndex',
  REPLACE_MARK = 'replaceMark',
  REPLACE_MARK_KB = 'replaceMarkKb',

  //* 홈 피드 쿼리 복원 상태
  HOME_FEED_QUERY_STATE = 'homeFeedQueryState',
  //* 타임라인 스크롤 히스토리 (섹션별 스크롤 + expanded 상태)
  TIMELINE_SCROLL_HISTORY = 'timelineScrollHistory',

  //* 비회원 세션 아이디
  GUEST_SESSION_ID = 'guestSessionId',

  //* 전역 팝업 마지막 노출 정보
  GLOBAL_POPUP_EXPOSURE = 'globalPopupExposure',

  //* 혜택탭 신규 오픈 공지 팝업을 본 적이 있는지 (1회 노출 후 종료)
  BENEFIT_OPEN_NOTICE_SHOWN = 'benefitOpenNoticeShown',

  //* 고향사랑기부 홈 답례품 목록 선택한 카테고리 그룹 코드
  DONATION_HOME_SELECTED_GIFT_CATEGORY_GROUP = 'donationHomeSelectedGiftCategoryGroup',

  //* 첫 기부 시 약관 동의 여부
  DONATION_AGREEMENT = 'donationAgreement',

  //* 답례품 문의하기로 문의하기 페이지로 이동했는지 여부
  IS_DONATION_INQUIRY_BY_GIFT_PRODUCT = 'donationInquiryByGiftProduct',

  //* KB 공통가입 1단계 입력값(본인인증 왕복 간 유지)
  KB_JOIN_COMMON_FORM = 'join-common-form',

  //* 로컬페스타 스플래시를 이미 봤는지 여부(재방문은 건너뛴다)
  LOCALFESTA_SPLASH_SHOWN = 'localfestaSplashShown',

  //* 카뱅 진입 토스트를 이 웹뷰 세션에서 이미 보여줬는지 여부
  KAKAOBANK_ENTRY_TOAST_SHOWN = 'kakaobankEntryToastShown',

  //* 체험단 후기 미작성 시트를 마지막으로 띄운 신청 ID (신청마다 1회 노출)
  GIFT_TRIAL_REVIEW_SHEET_SHOWN_APPLICATION_ID = 'giftTrialReviewSheetShownApplicationId',
}

/**
 * 로그아웃이면 **언제나** 비우는 세션 키.
 *
 * 로그인한 사용자의 조회·인증 결과라서 다음 사용자에게 이어지면 안 되고,
 * 비로그인 상태에서는 애초에 만들어지지 않으므로 clearSession에서 지워도 잃을 게 없다.
 *
 * 정리 대상을 호출부에 나열하면 키가 늘 때마다 조용히 누락되므로 여기서 관리한다.
 * 새 세션 키를 추가할 때 이 목록과 아래 목록 중 어디에 속하는지 함께 판단할 것.
 */
export const SESSION_KEYS_CLEARED_ON_LOGOUT = [
  STORAGE_KEY.POLICY_FILTER_LANDING,
  STORAGE_KEY.POLICY_FILTER,
  STORAGE_KEY.EASY_CERTIFICATION,
] as const;

/**
 * 사용자가 **실제로 로그아웃했을 때만** 비우는 진행 중 가입 상태.
 *
 * <b>{@code clearSession}에서는 남겨야 한다.</b> 가입은 원래 비로그인 상태로 진행되는데,
 * {@code AuthProvider}가 "토큰 없음"을 볼 때마다 {@code clearSession()}을 호출한다.
 * 여기에 가입 상태를 넣으면 가입 도중 화면을 옮길 때마다 지워져, 본인인증 왕복 후
 * 가입 세션을 잃고 로그인 회원용 API로 잘못 흘러 401이 난다(실제 발생한 회귀).
 *
 * 낡은 값 대비는 세 겹으로 되어 있다 — 만료 시 인증 콜백이 키를 정리하고,
 * 새 가입은 URL의 새 키로 덮어쓰며, 인증 콜백 분기는 usageCode를 함께 본다.
 */
export const SESSION_KEYS_CLEARED_ON_USER_LOGOUT = [
  STORAGE_KEY.SIGNUP_V3_USER_TEMP_KEY,
  STORAGE_KEY.SIGNUP_V3_LOCATION_CONSENT,
  STORAGE_KEY.KB_JOIN_COMMON_FORM,
  STORAGE_KEY.SIGNUP_METHOD,
  STORAGE_KEY.SIGNUP_TYPE,
] as const;

export namespace STORAGE_TYPE {
  export type HISTORY = [number, string][];
}
